import { createFileRoute } from "@tanstack/react-router";

import GmpLambBookings from "~/pages/GmpLambBookings";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute("/_private/gmp-lamb-bookings/$")({
  staticData: ROUTE_STATIC.gmpLambBookings,
  component: GmpLambBookings,
});
